import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Download, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Header } from "@/components/Header";
import { SnapMark } from "@/components/SnapMark";
import { api } from "@/lib/api";
import { downloadImage, shareWhatsApp } from "@/lib/share";
import { STUDIO } from "@/lib/studio";

export default function SharePage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/share/${id}`, { params: { format: "json" } }).then((r) => setData(r.data)).catch(() => setError("Bu görsel bulunamadı."));
  }, [id]);

  return (
    <div className="app-bg grain flex min-h-screen flex-col">
      <Header />
      <main className="relative z-10 mx-auto flex w-full max-w-md flex-1 flex-col items-center px-4 py-8 sm:px-6" data-testid="share-page">
        {error && <p className="glass mt-10 p-6 text-center text-slate-300" data-testid="share-error">{error}</p>}
        {data && (
          <>
            <p className="eyebrow">{data.share_title}</p>
            <h1 className="font-display mt-2 text-center text-2xl font-extrabold sm:text-3xl">{data.share_description}</h1>
            <div className="instax mt-6 w-full p-2">
              <img src={data.frame_url} alt="Karikatür" className="aspect-[3/4] w-full object-contain" data-testid="share-image" />
            </div>
            <div className="mt-6 grid w-full grid-cols-2 gap-3">
              <button className="btn btn-wa" onClick={() => shareWhatsApp({ imageUrl: data.frame_jpg_url, shareUrl: data.share_url, text: data.share_title, fileName: data.download_name })} data-testid="share-whatsapp-button">
                <MessageCircle size={18} /> WhatsApp
              </button>
              <button className="btn btn-ghost" onClick={() => downloadImage(data.frame_jpg_url, data.download_name).catch((e) => toast.error(e.message))} data-testid="share-download-button">
                <Download size={18} /> İndir
              </button>
            </div>
          </>
        )}
      </main>
      <footer className="relative z-10 flex items-center justify-center gap-2 py-6 text-xs tracking-[0.25em] text-slate-500 safe-bottom" data-testid="share-footer">
        <SnapMark size={16} /> {STUDIO.presents.toUpperCase()}
      </footer>
    </div>
  );
}
